module.exports = __webpack_public_path__ + "static/media/riffrMockup@2x.234ebdd4.png";